import type { ReactNode } from 'react'
import {
  isLegalBulletLine,
  isLegalMetaLine,
  isLegalSectionHeading,
  legalBulletText,
  legalSectionAnchorId,
} from '../../utils/parseLegalText'
import './LegalLinesBody.css'

type Props = {
  lines: string[]
}

export default function LegalLinesBody({ lines }: Props) {
  const nodes: ReactNode[] = []
  let index = 0

  while (index < lines.length) {
    const line = lines[index]

    if (index === 0) {
      nodes.push(<h1 key={`h1-${index}`}>{line}</h1>)
      index += 1
      continue
    }

    if (isLegalMetaLine(line, index)) {
      nodes.push(
        <p key={`meta-${index}`} className="legal-lines-date">
          {line}
        </p>,
      )
      index += 1
      continue
    }

    if (isLegalBulletLine(line)) {
      const items: string[] = []
      while (index < lines.length && isLegalBulletLine(lines[index])) {
        items.push(legalBulletText(lines[index]))
        index += 1
      }
      nodes.push(
        <ul key={`ul-${index}`} className="legal-lines-list">
          {items.map((item, itemIndex) => (
            <li key={itemIndex}>{item}</li>
          ))}
        </ul>,
      )
      continue
    }

    if (isLegalSectionHeading(line)) {
      const anchorId = legalSectionAnchorId(line)
      nodes.push(
        <h2 key={`h2-${index}`} id={anchorId}>
          {line}
        </h2>,
      )
      index += 1
      continue
    }

    nodes.push(<p key={`p-${index}`}>{line}</p>)
    index += 1
  }

  return (
    <div className="legal-lines-page">
      <div className="legal-lines-card">{nodes}</div>
    </div>
  )
}
